<fgb-page-header [pageTitle]="'wallet.redeemed.title'" [showBalance]="false" />

<div class="container">
  <ng-container *ifScreenSize="screenSize.Desktop">
    <div class="page-padding">
      <a class="cursor-pointer wallet-back-button mb-3" [routerLink]="'/rewards/wallet'">
        <span class="icon material-icons text-white">arrow_back_ios</span>
      </a>
    </div>
  </ng-container>

  <fgbcl-auction-wallet-details [id]="id"></fgbcl-auction-wallet-details>
</div>
